import React from 'react';
import { useTranslation } from "react-i18next";
import { AlertTriangle, LogOut } from 'lucide-react';
import { STATUS_CONFIG } from '../../utils/attendanceUtils';

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  if (status === 'late_early_departure') {
    return (
      <span className="inline-flex items-center gap-1">
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-950/30 text-red-400">
          <AlertTriangle className="h-3 w-3" />{t("attComp.statusBadge.late")}
        </span>
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-orange-950/30 text-orange-400">
          <LogOut className="h-3 w-3" />{t("attComp.statusBadge.earlyDep")}
        </span>
      </span>
    );
  }
  const cfg = STATUS_CONFIG[status] || { labelKey: null, color: 'bg-muted text-muted-foreground' };
  const Icon = cfg.icon;
  const label = cfg.labelKey ? t(cfg.labelKey) : status;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${cfg.color}`}>
      {Icon && <Icon className="h-3 w-3" />}
      {label}
    </span>
  );
};

export default StatusBadge;
